import "./bottomFloatingButton.scss";
import { DuplicateReservationModal } from "./home/HomeHallCard";
interface Props {
  partnerId: string | number;
  hallPayload?: any;
  buttonName: string;
  children?: any;
  isOpenWriteReviewModal?: boolean;
  // isOpenReservationModal?:boolean
  // setOpenReservationModal:(bool)=>void,
  onClose: () => void;
  handleRightBtnClick: () => void; //기본 버튼 클릭핸들러
  isDuplicateBooking: boolean; // 상담 중복예약 여부
  setIsDuplicateBooking: (bool) => void;
}
const BottomFloatingButton = ({
  hallPayload,
  buttonName,
  children,
  isOpenWriteReviewModal,
  onClose,
  handleRightBtnClick,
  isDuplicateBooking,
  setIsDuplicateBooking,
}: Props) => {
  return (
    <>
      <div className={`bottom-buttons-wrap`} style={{ display: buttonName === "" ? "none" : "" }}>
        <div className={`inner`}>
          {children}
          <button onClick={handleRightBtnClick} className="btn btn-giant btn-red500">
            {buttonName}
          </button>
        </div>
      </div>

      <DuplicateReservationModal
        isDuplicate={isDuplicateBooking}
        setIsDuplicate={setIsDuplicateBooking}
      />
    </>
  );
};

export default BottomFloatingButton;
